import { start, sendBeacon, configure } from './EventQueueProcessor';
import EventsLogger from './EventsLogger';

export { EventsLogger };
export { sendBeacon };
export { start };

export default {
    ...EventsLogger,
    start,
    sendBeacon,
    configure,
};
